import {CBARFrame} from "../CBARFrame";
import {CBARPipeline} from "./CBARPipeline";
import {CBAREvent} from "../../CBARTypes";
import {RenderOptions} from "../../components";

export abstract class CBARProcessNode {

    public enabled = true;

    protected constructor(public readonly pipeline:CBARPipeline) {

    }

    abstract update(frame:CBARFrame, renderOptions:RenderOptions):void;

    abstract debug(canvas:HTMLCanvasElement):void;

    abstract destroy():void;

    public handleEvent(event: CBAREvent) {}

    public refresh() {};
}